import { type ReactElement, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { H2 } from '@/Components/DataDisplay';

interface SectionCardProps {
    title?: ReactNode;
    description?: string;
    actions?: ReactNode;
    children?: ReactNode;
    className?: string;
}

/**
 * CARZELLE RETHEME — converted SectionCard.
 * Changes vs. original:
 *   • border-gray-200  → border-border   (was hardcoded; now follows the theme + dark mode)
 *   • rounded-xl       → rounded-lg      (token radius, var(--radius) = 10px)
 *   • title: text-base font-semibold → the shared <H2> component (sans, semibold)
 *            (the serif display face is reserved for <H1>; every subheading is sans)
 * Everything else is untouched; the API is identical.
 */
export function SectionCard({ title, description, actions, children, className }: SectionCardProps): ReactElement {
    return (
        <div className={cn("rounded-lg bg-card border border-border p-6", className)}>
            {(title || actions) && (
                <div className="mb-4">
                    <div className={cn("flex items-start justify-between", actions && "-mt-1.5 -mr-2")}>
                        <div className={cn(actions && "mt-1.5")}>
                            {title && <H2>{title}</H2>}
                            {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
                        </div>
                        {actions}
                    </div>
                </div>
            )}
            {children}
        </div>
    );
}
